export default "__VITE_ASSET__BCoghzJ3__"